// extracted by mini-css-extract-plugin
export default {"base":"user-image_base__P1qX-","fallback":"user-image_fallback__09cXB"};